export default __webpack_public_path__ + "static/media/file.659118d5.svg";